module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-03.f2a7f564.png";